import React from 'react';

import { UsuarioFaltandoDocumentacaoLista } from 'Component/Usuario';
import { useRecuperarUsuariosQuery } from 'Service';

const Documentacao = (): React.ReactElement => {
  const { data: { usuarios } = {} } = useRecuperarUsuariosQuery({
    finder: 'faltandoDocumentacao',
  });

  return (
    <div className="bg-white rounded shadow-sm">
      <div className="bg-primary text-white rounded-top py-2 px-3 fs-4 d-flex justify-content-between align-items-center">
        Documentação faltante
      </div>
      <div className="p-3 hf-500 overflow-auto rounded">
        {usuarios?.map((usuario) => (
          <UsuarioFaltandoDocumentacaoLista
            key={`${usuario.id}-${usuario.nome}`}
            dados={usuario}
          />
        ))}
      </div>
    </div>
  );
};

export default Documentacao;
